import Vue from 'vue'
import Router from 'vue-router'
import Layout from './components/Layout/Index'

Vue.use(Router);

export default new Router({
	// mode: 'history',
	routes: [
		{
			path: '*',
			name: 'Error',
			component: () => import('./views/Error')
		},
		{
			path: '/',
			name: 'Index',
			component: () => import('./views/Index')
		},
		{
			path: '/Index',
			name: 'Index',
			component: () => import('./views/Index')
		},
		// PC版找回密码
		{
			path: '/ForgotPassword',
			name: 'ForgotPassword',
			component: () => import('./views/ForgotPassword'),
			meta: {
				title: '비밀번호 찾기 - 슈탱크',
				description: '슈탱크 계정 비밀번호를 재설정합니다.'
			}
		},
		// 手机版路由
		{
			path: '/m',
			name: 'Mobile',
			component: () => import('./views/Mobile/Index')
		},
		{
			path: '/m/Download',
			name: 'MobileDownload',
			component: () => import('./views/Mobile/Download')
		},
		{
			path: '/m/Register',
			name: 'MobileRegister',
			component: () => import('./views/Mobile/Register')
		},
		{
			path: '/m/Pay',
			name: 'MobilePay',
			component: () => import('./views/Mobile/Pay')
		},
		{
			path: '/m/Discord',
			name: 'MobileDiscord',
			component: () => import('./views/Mobile/Discord')
		},
		{
			path: '/m/Account',
			name: 'MobileAccount',
			component: () => import('./views/Mobile/Account')
		},
		{
			path: '/m/Account/Password',
			name: 'MobileChangePassword',
			component: () => import('./views/Mobile/ChangePassword')
		},
		{
			path: '/m/Account/Nickname',
			name: 'MobileChangeNickname',
			component: () => import('./views/Mobile/ChangeNickname')
		},
		{
			path: '/m/Account/Email',
			name: 'MobileChangeEmail',
			component: () => import('./views/Mobile/ChangeEmail')
		},
		{
			path: '/m/Account/Gender',
			name: 'MobileChangeGender',
			component: () => import('./views/Mobile/ChangeGender')
		},
		{
			path: '/m/Guild/List',
			name: 'MobileGuildList',
			component: () => import('./views/Mobile/Guild/List')
		},
		{
			path: '/m/Guild/Detail',
			name: 'MobileGuildDetail',
			component: () => import('./views/Mobile/Guild/Detail')
		},
		{
			path: '/m/Guild/Create',
			name: 'MobileGuildCreate',
			component: () => import('./views/Mobile/Guild/Create')
		},
		{
			path: '/m/Guild/Apply',
			name: 'MobileGuildApply',
			component: () => import('./views/Mobile/Guild/Apply')
		},
		{
			path: '/m/ForgotUsername',
			name: 'MobileForgotUsername',
			component: () => import('./views/Mobile/ForgotUsername')
		},
		{
			path: '/m/ForgotPassword',
			name: 'MobileForgotPassword',
			component: () => import('./views/Mobile/ForgotPassword')
		},
		{
			path: '/Fortress/MemberDonate/:id',
			name: 'MemberDonate',
			component: () => import('./views/Fortress/MemberDonate')
		},
		{
			path: '/Home',
			component: Layout,
			children: [
				{
					path: '',
					name: '首页',
					component: () => import('./views/Home/Index')
				},
				{
					path: '/Home/Guild/Index',
					name: '战队列表',
					component: () => import('./views/Home/Guild/Index'),
				},
				{
					path: '/Home/Guild/Detail',
					name: '战队详情',
					component: () => import('./views/Home/Guild/Detail')
				},
				{
					path: '/Home/Guild/Create',
					name: '创建战队',
					component: () => import('./views/Home/Guild/Create')
				},
				{
					path: '/Home/Guild/Apply',
					name: '加入申请',
					component: () => import('./views/Home/Guild/Apply')
				},
				{
					path: '/Home/User/Index',
					name: '账号信息',
					component: () => import('./views/Home/User/Index')
				},
				{
					path: '/Home/User/MotifyPassword',
					name: '修改密码',
					component: () => import('./views/Home/User/MotifyPassword')
				},
				{
					path: '/Home/User/MotifyAliasName',
					name: '修改昵称',
					component: () => import('./views/Home/User/MotifyAliasName')
				},
				{
					path: '/Home/User/Donate',
					name: '捐款',
					component: () => import('./views/Home/User/Donate')
				},
				{
					path: '/Home/User/MotifyEmail',
					name: '修改邮箱地址',
					component: () => import('./views/Home/User/MotifyEmail'),
					meta: {
						title: '이메일 수정 - 슈탱크',
						description: '슈탱크 이메일 주소를 수정합니다.'
					}
				},
				{
					path: '/Home/User/MotifySex',
					name: '修改用户性别',
					component: () => import('./views/Home/User/MotifySex'),
					meta: {
						title: '성별 수정 - 슈탱크',
						description: '슈탱크 성별 정보를 수정합니다.'
					}
				}
			]
		},
	]
})

const VueRouterPush = Router.prototype.push

Router.prototype.push = function push(to) {
	return VueRouterPush.call(this, to).catch(err => err)
}
